import { useTranslation } from "react-i18next";

import { Step } from ".";
import { Color } from "../../Form/Button";

export enum TypeOfButton {
  SUBMIT = "submit",
  CANCEL = "cancel",
}

export type SetButton = {
  type: string;
  isToUpdate: boolean;
  options: string[];
  steps: Step[];
};

export const useStepsAction = () => {
  const { t: translate } = useTranslation();

  const setButton = (button: SetButton): { color: Color; text: string } => {
    const { type, isToUpdate, options, steps } = button;

    if (type === TypeOfButton.SUBMIT) {
      if (options.length < steps.length && !isToUpdate)
        return { color: Color.SECONDARY, text: translate("next") };

      if (isToUpdate) return { color: Color.SUCCESS, text: translate("update") };

      return { color: Color.SUCCESS, text: translate("create") };
    }

    if (options.length > 1 && !isToUpdate)
      return { color: Color.TEXT_INFO, text: translate("back") };

    return { color: Color.CANCEL, text: translate("cancel") };
  };

  const onNextStep = (options: string[], steps: Step[], callback: (nextOption: string) => void) => {
    for (const step of steps) {
      if (!options.includes(step.key)) {
        callback(step.key);

        return;
      }
    }
  };

  const onPreviousStep = (
    options: string[],
    callback: (nextOptions: string[], nextStep: string) => void
  ) => {
    const nextCurrentStep = options[options.length - 2];
    const nextOptions = options;

    nextOptions.pop();
    callback(nextOptions, nextCurrentStep);
  };

  const onCancel = (
    options: string[],
    isToUpdate: boolean,
    callback: Function,
    callbackPreviousStep: (nextOptions: string[], nextStep: string) => void
  ) => {
    if (options.length > 1 && !isToUpdate) onPreviousStep(options, callbackPreviousStep);
    else callback();
  };

  const onFinish = (
    isValid: boolean,
    isToUpdate: boolean,
    options: string[],
    steps: Step[],
    callback: Function,
    callbackNextStep: (nextOptions: string) => void
  ) => {
    if (isValid) {
      if (options.length < steps.length && !isToUpdate)
        onNextStep(options, steps, callbackNextStep);
      else callback();
    }
  };

  return {
    setButton,
    onCancel,
    onFinish,
  };
};
